import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=a421c0aa&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a421c0aa')) {
      api.createRecord('a421c0aa', component.options)
    } else {
      api.reload('a421c0aa', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=a421c0aa&", function () {
      api.rerender('a421c0aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wu21Z1sL3wNk/JS/comp/childrenage.vue"
export default component.exports